import React, { useEffect, useState } from 'react';
import Modal from '../../../modal/modal';
import { Translations } from '../mapbox-with-service-areas';

interface Props {
	getDefaultName: () => string;
	visible: boolean;
	onOk: (areaName: string) => void;
	onCancel: () => void;
	translations: Translations;
}

const ApproveServiceAreaModal: React.FC<Props> = props => {
	const { getDefaultName, visible, onOk, onCancel, translations } = props;
	const [areaName, setAreaName] = useState('');

	const onChange = e => {
		setAreaName(e.target.value);
	};

	const onOkClicked = () => {
		onOk(areaName);
	};

	const onCancelClicked = () => {
		onCancel();
	};

	useEffect(() => {
		if (!visible) setAreaName('');
	}, [visible]);

	useEffect(() => {
		setAreaName(getDefaultName);
	}, [getDefaultName]);

	return (
		<Modal
			title={translations.areaName}
			className="mapbox-with-service-areas-modal"
			visible={visible}
			onOk={onOkClicked}
			onCancel={onCancelClicked}
			footer={
				<div className="modal-footer">
					<button
						type="button"
						className="modal-footer-button modal-footer-button-cancel"
						onClick={onCancelClicked}
					>
						{translations.cancel}
					</button>
					<button
						type="button"
						className="modal-footer-button modal-footer-button-save"
						data-dismiss="modal"
						onClick={onOkClicked}
					>
						{translations.save}
					</button>
				</div>
			}
		>
			<input className="modal-body" type="text" onChange={onChange} value={areaName} defaultValue={areaName} />
		</Modal>
	);
};

export default ApproveServiceAreaModal;
